import  useNavigation from '../../../hooks/useNavigation.js'
import StatusBadge from '../../common/helper/transaction-status.component.js';

export const cryptoListColumnsAgents = () => {
    const { navigateTo } = useNavigation();

    return [
  
        {
          name: 'Full Name',
         // selector: row => row.full_name,
          sortable: true,
          cell: row => <div className="custom-cell-fullName">{row.name || '-'}</div>,
         // style: row => ({ minWidth: '100px' }),
        },
        {
          name: 'Agent Code',
         // selector: row => row.full_name,
          sortable: true,
          cell: row => <div className="custom-cell-fullName">{row.agent_code || '-'}</div>,
         // style: row => ({ minWidth: '100px' }),
        },
        {
          name: 'Order ID',
          selector: row => <div className="custom-cell-order_Code_crypto">{row.order_id}</div>,
          sortable: true,
          //style: row => ({ minWidth: '100px' }),
        },
        {
          name: 'Type',
          selector: row => <div className="custom-cell-request_type">{row.request_type == 'B' ? 'Buy':'Sell'}</div>,
          sortable: true,
          //style: row => ({ minWidth: '100px' }),
        },
        {
          name: 'Status',
          //selector: row => row.email_address,
          cell: row =>   <StatusBadge status={row.status} />,
          sortable: true,
         // style: row => ({ minWidth: '100px' }),
        },
       
        {
          name: 'Requested Quantity',
          //selector: row => row.email_address,
          cell: row => row.requested_quantity ? '₹' + row.requested_quantity:'₹0',
          sortable: true,
         // style: row => ({ minWidth: '100px' }),
        },
        {
          name: 'Approved Quantity',
          //selector: row => row.email_address,
          cell: row => row.approved_quantity ? '₹' + row.approved_quantity:'₹0',
          sortable: true,
         // style: row => ({ minWidth: '100px' }),
        },
        {
          name: 'Requested Rate',
          //selector: row => row.email_address,
          cell: row =>row.requested_rate ? '₹' + row.requested_rate:'₹0',
          sortable: true,
         // style: row => ({ minWidth: '100px' }),
        },
        {
          name: 'Approved Rate',
          //selector: row => row.email_address,
          cell: row => row.approved_rate ? '₹' + row.approved_rate:'₹0',
          sortable: true,
         // style: row => ({ minWidth: '100px' }),
        },
        {
          name: 'Created_on',
          //selector: row => row.email_address,
          cell: row => <div className="custom-cell-email_address">{row.created_on}</div>,
          sortable: true,
         // style: row => ({ minWidth: '100px' }),
        },
        {
          name: "Actions",
          button: true,
          style: row => ({ zIndex:0 }),
          cell: row =>
           <>
    
            <a className={`fview tooltip ${row.status === 'Rejected' ? 'disable' : ''}`} style={{'cursor':'pointer'}}  onClick={() => ViewCrypto('viewCrypto','view-crypto',row.id)}>
             <i className={`fa ${ row.status === 'Rejected' ? 'fa-eye disable' : 'fa-eye'}`} />
              <span className="tooltiptext">View</span>
            </a>
             
             
              {row.status =='I' && (
              <a className={`fedit tooltip ${row.status === 'Active' || row.status === 'Rejected' ? 'disable' : ''}`} onClick={() => approveCrypto('ApproveCrypto','approve-crypto',row)} style={{'cursor':'pointer'}}>
                <i className={`fa ${row.status === 'Active' || row.status === 'Rejected'|| row.is_verification_pending ? 'fa-check-circle disable' : 'fa-check-circle'}`}  />
                <span className="tooltiptext">Approve</span>
              </a>)}
              
              </>
       
        }
      ]
  }
  
  export const cryptoColumnsMerchants = () => {
    const { navigateTo } = useNavigation();

    return [
  
        {
            name: 'Full Name',
           // selector: row => row.full_name,
            sortable: true,
            cell: row => <div className="custom-cell-fullName">{row.name || '-'}</div>,
           // style: row => ({ minWidth: '100px' }),
          },
         
          {
            name: 'Order ID',
            selector: row =>  <div className="custom-cell-order_Code_crypto">{row.order_id}</div>,
            sortable: true,
            //style: row => ({ minWidth: '100px' }),
          },
          {
            name: 'Type',
            selector: row => <div className="custom-cell-request_type">{row.request_type == 'B' ? 'Buy':'Sell'}</div>,
            sortable: true,
            //style: row => ({ minWidth: '100px' }),
          },
          {
            name: 'Status',
            //selector: row => row.email_address,
            cell: row =>   <StatusBadge status={row.status} />,
            sortable: true,
           // style: row => ({ minWidth: '100px' }),
          },
         
          {
            name: 'Requested Quantity',
            //selector: row => row.email_address,
            cell: row => row.requested_quantity ? '₹' + row.requested_quantity:'₹0',
            sortable: true,
           // style: row => ({ minWidth: '100px' }),
          },
          {
            name: 'Approved Quantity',
            //selector: row => row.email_address,
            cell: row => row.approved_quantity ? '₹' + row.approved_quantity:'₹0',
            sortable: true,
           // style: row => ({ minWidth: '100px' }),
          },
          {
            name: 'Requested Rate',
            //selector: row => row.email_address,
            cell: row =>row.requested_rate ? '₹' + row.requested_rate:'₹0',
            sortable: true,
           // style: row => ({ minWidth: '100px' }),
          },
          {
            name: 'Approved Rate',
            //selector: row => row.email_address,
            cell: row => row.approved_rate ? '₹' + row.approved_rate:'₹0',
            sortable: true,
           // style: row => ({ minWidth: '100px' }),
          },
          {
            name: 'Created_on',
            //selector: row => row.email_address,
            cell: row => <div className="custom-cell-email_address">{row.created_on}</div>,
            sortable: true,
           // style: row => ({ minWidth: '100px' }),
          },
        {
          name: "Actions",
          button: true,
          style: row => ({ zIndex:0 }),
          cell: row =>
           <>
    
            <a className={`fview tooltip ${row.status === 'Rejected' ? 'disable' : ''}`} style={{'cursor':'pointer'}}  onClick={() => ViewCrypto('viewCrypto','view-crypto',row.id)}>
             <i className={`fa ${ row.status === 'Rejected' ? 'fa-eye disable' : 'fa-eye'}`} />
              <span className="tooltiptext">View</span>
            </a>
             
             
              {row.status =='I' && (
              <a className={`fedit tooltip ${row.status === 'Active' || row.status === 'Rejected' ? 'disable' : ''}`} onClick={() => approveCrypto('ApproveCrypto','approve-crypto',row)} style={{'cursor':'pointer'}}>
                <i className={`fa ${row.status === 'Active' || row.status === 'Rejected'|| row.is_verification_pending ? 'fa-check-circle disable' : 'fa-check-circle'}`}  />
                <span className="tooltiptext">Approve</span>
              </a>)}
              
              </>
       
        }
      ]
  }